import actions from './actions';
import getters from './getters';
import mutations from './mutations';
import formdata from './formdata'

const state = {
    data: {
        entity_id:null,
        unit_id:null,
        treatment_ids:[],
        ingredient_id:null,
        unitvalue:'',
        preparation_ids:[],
        notices:'',
        cookingloss:'',
        prepareloss:'',
        duplicate:false
    },
    recipesteps:[],
    forrecipe:[]
   
    
};

export default {
    modules: {
        formdata: formdata,
        
    },
    namespaced: true,
    state,
    actions,
    getters,
    mutations,
};